import MUserInvitationUploadRadio from './index.vue';

MUserInvitationUploadRadio.install = app => {
  app.component(MUserInvitationUploadRadio.name, MUserInvitationUploadRadio);
};

export default MUserInvitationUploadRadio;
